import Chart from 'react-apexcharts';
import { currentDatabaseSelector } from '@transport-insights/uikit';
import { useRecoilValue } from 'recoil';
import { useE3HistoricalData } from '@src/modules/performance/context/reports-api-hooks';
import { Link, Text } from '@chakra-ui/react';
import { CHART_COLOURS } from '@src/modules/performance/shared/constants';
import ReportSection from './ReportSection';

const informationSource = {
  title: 'Trend in pavement and drainage renewal quantity',
  content: [
    {
      title: 'Length of renewal work done as % of network lane km',
      description:
  <Text fontSize="inherit" mb={2}>
    The trend in the amount in kilometres of road renewal carried out for road resurfacing, pavement rehabilitation, and kerb and channel drainage per annum as a percentage of the lane kms in the network. The Efficiency and Effectiveness calculations include the work done to date for the last three years.
  </Text>,
      source:
  <Text fontSize="inherit" as="span">
    Sourced from TIO and
    {' '}
    <Link href="https://www.nzta.govt.nz/planning-and-investment/learning-and-resources/transport-data/data-and-tools" isExternal>NZTA Data and Tools, Physical statistics - roads.</Link>
  </Text>,
    },
  ],
};

function E3Quantity() {
  const currentDatabase = useRecoilValue(currentDatabaseSelector);
  const { data: historicalData, isLoading: isLoadingHistoricalData } = useE3HistoricalData();
  const isRegionNationalOrStateHighways = currentDatabase?.id === 81 || currentDatabase?.id >= 1000;

  const sortedHistoricalData = historicalData?.sort((a, b) => a.year - b.year);
  const years = [...new Set(sortedHistoricalData?.map((x) => x.year).flat())];

  const historicalLockYear = sortedHistoricalData?.at(-1)?.lockYear;

  const chartData = [
    {
      name: currentDatabase?.name,
      type: 'line',
      data: historicalData?.map((x) => x.quantity) || [],
      color: CHART_COLOURS.orange,
    },
    {
      name: 'Peer Group',
      type: 'line',
      data: historicalData?.map((x) => x.peerGroupQuantity) || [],
      color: CHART_COLOURS.black,
    },
  ];

  const chartSeries = isRegionNationalOrStateHighways
    ? [...chartData.filter((x) => !x.name?.includes('Peer'))]
    : [...chartData];

  return (
    <ReportSection
      title="Trend in pavement and drainage renewal quantity"
      lockYear={historicalLockYear}
      isLoading={isLoadingHistoricalData}
      informationSource={informationSource}
    >
      <Chart
        options={
            {
              title: {
                text: ['Length of renewal work done', 'as % of network lane km'],
              },
              chart: {
                animations: {
                  enabled: false,
                },
              },
              xaxis: {
                categories: years || [],
              },
              yaxis: [
                {
                  min: 0,
                  forceNiceScale: false,
                  title: {
                    text: '% of network lane km',
                  },
                  labels: {
                    formatter(val) {
                      return `${val.toFixed(1)}%`;
                    },
                    offsetX: 0,
                  },
                },
              ],
              grid: {
                padding: {
                  left: 20,
                },
              },
              dataLabels: {
                enabled: false,
              },
              legend: {
                show: true,
              },
            }
        }
        series={chartSeries}
        type="line"
        width="100%"
        height="240"
      />
    </ReportSection>
  );
}

export default E3Quantity;
